import { Button, Divider, Grid, Typography } from "@mui/material";
import { Box } from "@mui/material";
import styles from "./homepage.module.css";
import RotoGPT from "../../assets/RotoGPT.png";
import PhoneWebsite from "../../assets/PhoneWebsite.png";
import NavBar from "src/components/NavBar/NavBar";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import DividerHome from "src/components/Divider/DividerHome";
import FeaturesSection from "src/components/HomeSections/FeaturesSection";
import BenefitsSection from "src/components/HomeSections/BenefitsSection";
import SportsSection from "src/components/HomeSections/SportsSection";
import PartnersSection from "src/components/HomeSections/PartnersSection";
import DemoSection from "src/components/HomeSections/DemoSection";

// console.log("Auth0 Domain:", process.env.REACT_APP_AUTH0_DOMAIN);
// console.log("Frontend URI:", process.env.REACT_APP_FRONTEND_URI_WEB);
// console.log("Callback URI:", callbackUri);
function HomePage() {
  return (
    <Box sx={{ maxWidth: { lg: "1200px", xs: "auto" }, m: "auto" }}>
      <NavBar />

      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-around"
        alignItems="center"
        sx={{
          marginTop: "64px",
        }}
      >
        <Box display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" p={2} pt={{ lg: 2, xs: 8 }} textAlign="center">
          <Typography
            fontSize={{ xs: "24px", md: "40px" }}
            width={{ xs: 300, md: 500 }}
            fontWeight={400}
            color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
            lineHeight={1.2}
            fontFamily="Oswald, Arial"
          >
            REVOLUTIONIZE YOUR FANTASY BRAND WITH
          </Typography>
          <Box pt={2}>
            <img src={RotoGPT} alt="RotoGPT" className={styles.imgRotoGPT} />
          </Box>
          <Box pt={2}>
            <Typography
              variant="h3"
              fontSize={{ xs: "16px", md: "20px" }}
              pt={3}
              fontWeight={700}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
              lineHeight={1.2}
              fontFamily="Oswald, Arial"
            >
              White-Label Fantasy Sports Chatbot
            </Typography>
            <Typography
              variant="h5"
              fontSize={{ xs: "14px", md: "18px" }}
              p={1}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
              lineHeight={1.2}
              fontFamily="Roboto, Arial"
            >
              Provide Real-Time Insights, Predictions, and Management Advice
            </Typography>
            <Typography
              variant="h3"
              fontSize={{ xs: "16px", md: "20px" }}
              fontWeight={700}
              pt={3}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
              lineHeight={1.2}
              fontFamily="Oswald, Arial"
            >
              Leverage the Power of Generative AI
            </Typography>
            <Typography
              variant="h5"
              fontSize={{ xs: "14px", md: "18px" }}
              p={1}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
              lineHeight={1.2}
              fontFamily="Roboto, Arial"
            >
              Enhance Your Users' Fantasy Sports Experience
            </Typography>
            <Typography
              variant="h3"
              fontSize={{ xs: "16px", md: "20px" }}
              fontWeight={700}
              pt={3}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
              lineHeight={1.2}
              fontFamily="Oswald, Arial"
            >
              Incremental Growth Opportunity
            </Typography>
            <Typography
              variant="h5"
              fontSize={{ xs: "14px", md: "18px" }}
              p={1}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
              lineHeight={1.2}
              fontFamily="Roboto, Arial"
            >
              Generate new revenue streams with existing/new customers
            </Typography>
          </Box>
        </Box>
        <Box pt={4.5}>
          <img src={PhoneWebsite} alt="RotoGPT" className={styles.imgRotoGPTPhone} />
        </Box>
      </Box>

      {/* -------------------------- */}

      <Box pt={5} sx={{ pb: { lg: 5, xs: 0 } }} display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        <a href="/contact">
          <Button
            size="large"
            variant="contained"
            color="warning"
            sx={{
              borderRadius: 0.5,
              width: { lg: "350px", sm: "350px", xs: "250px" },
              fontFamily: "oswald",
              "&:hover": {
                backgroundColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
              },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: "30px", sm: "20px" },
                fontFamily: "Oswald, Arial",
                color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              }}
            >
              TRY ROTOGPT
            </Typography>
          </Button>
        </a>
      </Box>

      <DividerHome />
      {/* Features section at home */}
      <FeaturesSection />

      <DividerHome />
      {/* Benefits section at home */}
      <BenefitsSection />

      <DividerHome />
      {/* Sport section at home */}
      <SportsSection />

      <DividerHome />
      {/* Partners section at home */}
      <PartnersSection />

      <DividerHome />
      {/* Demo section at home */}
      <DemoSection />
    </Box>
  );
}

export default HomePage;
